import React from "react";
import NewTooltips from "../../../assets/icons/NewTooltips";

const TooltipDropdown = ({
  toolTipText,
  isHovered,
}: {
  toolTipText: string;
  isHovered: boolean;
}) => {
  return (
    <div className="relative">
      <NewTooltips />
      {isHovered && toolTipText && toolTipText.length > 0 && (
        <div className="absolute  md:left-[-7.2em] left-[-4.0em] z-50">
          <div className="flex items-center justify-center">
            <svg
              width="18"
              height="15"
              viewBox="0 0 18 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M9 0L17.6603 15H0.339746L9 0Z" fill="white" />
            </svg>
          </div>
          <div className="md:w-[246px]  w-[140px] text-center p-3 bg-white text-gray-500 rounded-[8px] text-[12px] font-medium leading-[14.4px]  shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1),0_2px_4px_-1px_rgba(0,0,0,0.06)]">
            {toolTipText}
          </div>
        </div>
      )}
    </div>
  );
};

export default TooltipDropdown;
